import { MESSAGE_TYPES, ERROR_MESSAGES } from './MessageTypes';
import { logger } from '@/utils/logger';

/**
 * Iframe消息发送器
 * 负责向iframe发送各种类型的消息
 */
export class IframeMessageSender {
  /**
   * 发送消息到iframe
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} messageData - 消息数据
   */
  sendMessage(iframe, messageData) {
    if (!this._validateIframe(iframe)) {
      return;
    }

    try {
      iframe.contentWindow.postMessage(messageData, '*');
      logger.debug('[IframeMessageSender] 消息发送成功', {
        type: messageData.type,
        data: messageData.data,
      });
    } catch (error) {
      logger.error('[IframeMessageSender] 消息发送失败', {
        type: messageData.type,
        error: error.message,
      });
      throw error;
    }
  }

  /**
   * 发送初始化消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} credentials - 登录凭证
   * @param {string} conversationId - 会话ID
   * @param {string} groupOwnerId - 群组所有者ID
   */
  sendInitMessage(iframe, credentials, conversationId, groupOwnerId) {
    const messageData = {
      type: MESSAGE_TYPES.INIT_CHAT,
      data: {
        sdkAppId: credentials.sdkAppId,
        userId: credentials.userId,
        userSig: credentials.userSig,
        conversationId,
        groupOwnerId,
      },
    };

    this.sendMessage(iframe, messageData);
  }

  /**
   * 发送切换会话消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} conversationId - 会话ID
   * @param {string} serviceUserId - 服务用户ID
   * @param {Object} credentials - 登录凭证
   * @param {string} groupOwnerId - 群组所有者ID
   */
  sendSwitchConversationMessage(iframe, conversationId, serviceUserId, credentials, groupOwnerId) {
    // 确保会话ID有正确的GROUP前缀
    const formattedConversationId = conversationId.toString().startsWith('GROUP')
      ? conversationId
      : `GROUP${conversationId}`;

    const messageData = {
      type: MESSAGE_TYPES.SWITCH_CONVERSATION,
      data: {
        conversationId: formattedConversationId,
        serviceUserId,
        userId: credentials?.userId || serviceUserId,
        credentials,
        groupOwnerId,
      },
    };

    this.sendMessage(iframe, messageData);
  }

  /**
   * 发送注销消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} reason - 注销原因
   */
  sendLogoutMessage(iframe, reason = 'manual') {
    const messageData = {
      type: MESSAGE_TYPES.LOGOUT,
      data: { reason },
    };

    this.sendMessage(iframe, messageData);
  }

  /**
   * 验证iframe是否有效
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @returns {boolean} 是否有效
   */
  _validateIframe(iframe) {
    if (!iframe) {
      logger.error('[IframeMessageSender]', ERROR_MESSAGES.IFRAME_NOT_EXISTS);
      return false;
    }

    if (!iframe.contentWindow) {
      logger.error('[IframeMessageSender]', ERROR_MESSAGES.IFRAME_NOT_CONFIGURED);
      return false;
    }

    return true;
  }
}
